import { useGetDocumentExtractsByAccountQuery } from '@/services/genai';
import { PalmettoIcon } from '@palmetto/dsm-components';
import React, { useCallback, useState } from 'react';

import { AiAssistantAccountDocumentsAccordion } from './AiAssistantAccountDocumentsAccordion';

interface DocumentExtractionsGroupProps {
  accountId: string;
}

export const DocumentExtractionsGroup: React.FC<DocumentExtractionsGroupProps> = ({ accountId }) => {
  const { data, error } = useGetDocumentExtractsByAccountQuery(accountId);
  const [isOpen, setIsOpen] = useState(false);
  const contentId = React.useId();

  const handleToggle = useCallback(() => setIsOpen((prev) => !prev), []);

  if (!data?.length && !error) return null;

  // Force the panel open when the query errors so the failure isn't hidden behind a collapsed group.
  const isExpanded = isOpen || Boolean(error);

  return (
    <div>
      <button
        type="button"
        aria-expanded={isExpanded}
        aria-controls={contentId}
        onClick={handleToggle}
        className="flex w-full items-center gap-8 text-left text-sm font-medium text-text-primary"
      >
        <PalmettoIcon name={isExpanded ? 'chevronDown' : 'chevronRight'} size="sm" />
        Document Data Extractions
      </button>
      <div id={contentId} hidden={!isExpanded}>
        <AiAssistantAccountDocumentsAccordion accountId={accountId} />
      </div>
    </div>
  );
};
